import {
	CheckboxField,
	EntityDrawerProps,
	FCC,
	FormDrawer,
	FormDrawerContent,
	SingleSelectField,
	TextField,
} from "@dgs/core";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { CountrySelectField } from "../../../../shared/ui/CountrySelectField";
import { ALL_ADDRESS, AddressFormState } from "../../shared/types/address";

export const ContactAddressDrawer: FCC<EntityDrawerProps<AddressFormState>> = ({ children, ...props }) => {
	const { t } = useTranslation();

	const validate = useCallback(
		(values: AddressFormState) => {
			const errors: { [K in keyof AddressFormState]?: any } = {};

			if (!values.street) {
				errors.street = t("Required field");
			}
			if (!values.houseNumber) {
				errors.houseNumber = t("Required field");
			}
			if (!values.zip) {
				errors.zip = t("Required field");
			}
			if (!values.city) {
				errors.city = t("Required field");
			}
			if (!values.country) {
				errors.country = t("Required field");
			}
			return errors;
		},
		[t],
	);

	return (
		<FormDrawer
			{...props}
			validate={validate}
			renderForm={(props) => (
				<FormDrawerContent {...props}>
					<TextField name="street" label={t("Street")} required />
					<TextField name="houseNumber" label={t("House number")} required />
					<TextField name="additionalInfo" label={t("Additional info")} />
					<TextField name="zip" label={t("Zip")} required />
					<TextField name="city" label={t("City")} required />
					<CountrySelectField name="country" label={t("Country")} required />
					<SingleSelectField
						options={ALL_ADDRESS.map((x) => ({ label: t(x), value: x }))}
						getLabel={(x) => x.label}
						getValue={(x) => x.value}
						name="type"
						label={t("Type")}
						clearable={false}
					/>
					<CheckboxField label={t("Mark as primary")} name="isPrimary" />
					{children}
				</FormDrawerContent>
			)}
		/>
	);
};
